@if (products?.length > 0) {
  <div class="container products deal">
    <div class="heading heading-flex heading-border mb-3" contentAnim aniName="blurIn">
      <div class="heading-left">
        <h2 class="title">Hot Deals Products</h2>
      </div>
      <!-- **************** Heading right not needed ***********************************
      <div class="heading-right">
        <ul class="nav nav-pills nav-border-anim justify-content-center" role="tablist" tabClick>
          <li class="nav-item" *ngFor="let cat of cats; let index = index">
            <a class="nav-link" [class.active]="index === 0" href="" role="tab"
            (click)="nav.select( 'deal-' + cat )">{{ titles[cat] }}</a>
          </li>
        </ul>
      </div>
      -->
    </div>
    <owl-carousel-o carouselClasses="owl-simple carousel-equal-height carousel-with-shadow" [options]="customOptions">
      @for (product of products; track product.id; let productIndex = $index) {
        <ng-template carouselSlide [id]="'hot-deal-' + (product.id || productIndex)">
          <molla-product-twelve [product]="product"></molla-product-twelve>
        </ng-template>
      }
    </owl-carousel-o>
  </div>
}
